"use client";

import { resolveObjectArray } from "./binding";
import type { MacaronRenderContext, RecordAny } from "./types";

export function MacaronOrderedDisplayList({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const items = resolveObjectArray(config.items, ctx.data).map((item) => (typeof item.child === "string" ? item.child : "")).filter((item): item is string => Boolean(item));
  if (items.length === 0) return null;
  return (
    <ol className="flex list-decimal flex-col gap-1 pl-5 text-sm text-[#344054]">
      {items.map((item) => (
        <li key={item}>{ctx.renderChild(item)}</li>
      ))}
    </ol>
  );
}
